exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-a75c9c72] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n  /* #E4E5E7 */\n}\n.main-wrapper[data-v-a75c9c72] {\n  background: #f7f7f8;\n  padding: 32px;\n  margin-top: 64px;\n}\n.content-container[data-v-a75c9c72] {\n  background: #ffffff;\n  border-radius: 4px;\n  min-height: calc(100vh - 248px);\n  margin-top: 32px;\n}\n", ""]);

// exports
